import dayjs from 'dayjs';
import i18n from '@/app/locales/locale';
import { ICellRendererParams } from 'ag-grid-community';

// @ts-ignore
const { t } = i18n.global;

export const codedRenderer = (params: ICellRendererParams) => {
  if (params.value === undefined) {
    return ``;
  } else {
    return params.value
      ? `<span title='Attribute is coded' class='material-icons-outlined atb-align-middle'>insert_drive_file</span>`
      : `<img title='This Attribute has not been coded yet' src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjAgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5ICg4NjEyNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+ZHJhZyBoYW5kbGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iQXR0cmlidXRlcyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkF0dHJpYnV0ZXMtLS1BbGwtQXR0cmlidXRlcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc1MS4wMDAwMDAsIC00MzcuMDAwMDAwKSIgZmlsbD0iI0U0MDAyQiI+CiAgICAgICAgICAgIDxnIGlkPSJUYWJsZXMtLy0wMi0tLWRhdGEtY2VsbHMtLy0xMy0tLWRlZmF1bHQsLWRyYWcsLW1pZGRsZS1yb3dzLUNvcHktMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczNC4wMDAwMDAsIDQyOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJUYWJsZXMtLy0wMi0tLWRhdGEtY2VsbHMtLy0wOS0tLWRlZmF1bHQsLWNoZWNrYm94LC1taWRkbGUtcm93cyI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImV4cGVyaWFuL25vdGVzX2hpZGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjAwMDAwMCwgNy41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLjcwNyw0IEwxMi43MDcsOSBMMTcuNzA3LDkgTDE3LjcwNywxNC44NzkgTDE5LjcwNywxNi44NzkgTDE5LjcwNyw4IEwxMy43MDcsMiBMNS43MDcsMiBDNS40NDgsMiA1LjIwMSwyLjA1NCA0Ljk3MywyLjE0NSBMNi44MjgsNCBMMTIuNzA3LDQgWiBNNS43MDcsMjAgTDUuNzA3LDguNDE0IEwxNy4yOTMsMjAgTDUuNzA3LDIwIFogTTIxLjQxNCwyMS4yOTMgTDMuNDE0LDMuMjkzIEwyLDQuNzA3IEwzLjcwNyw2LjQxNCBMMy43MDcsMjAgQzMuNzA3LDIxLjEgNC41OTcsMjIgNS42OTcsMjIgTDE3LjcwNywyMiBDMTguMTUyLDIyIDE4LjU1MiwyMS44NCAxOC44ODMsMjEuNTkgTDIwLDIyLjcwNyBMMjEuNDE0LDIxLjI5MyBaIiBpZD0iZmlsbCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"/>`;
  }
};

export const systemsRenderer = (params: ICellRendererParams) => {
  if (params.value && params.value.length) {
    const systems = params.value
      .reduce((pv: Array<any>, cv: any) => {
        pv.push(cv.systemName);
        return pv;
      }, [])
      .join(', ');
    return `<span>${systems}</span>`;
  } else return ``;
};

export const lastUpdatedRenderer = ({ value, data }: ICellRendererParams) => {
  if (value) {
    const updatedDate = dayjs(value).format('MMM DD YYYY HH:mmZ');
    const { lastUpdatedByUsername } = data;
    const updatedBy = lastUpdatedByUsername
      ? updatedDate + ' by ' + lastUpdatedByUsername || ''
      : updatedDate;
    return updatedBy;
  }
};

export const createdByRenderer = (params: ICellRendererParams) => {
  if (params.value) {
    const createdDate = dayjs(params.value).format('MMM DD YYYY HH:mmZ');
    const createdBy = params.data.createdBy || '';
    return `<span>${createdDate} by ${createdBy}</span>`;
  } else return ``;
};

export const versionNumberRenderer = (params: ICellRendererParams) => {
  const versionNumber = Number(params.data?.versionNumber);
  if (!Number.isFinite(versionNumber) || versionNumber === 0) {
    return ``;
  }
  if (Number(params.data.currentVersion) === versionNumber) {
    return `<span class = 'eds-link underline' style='cursor: pointer'>${params.data.versionNumber}</span><span class='text-red-400'>*</span>`;
  }
  return `<span class = 'eds-link underline' style='cursor: pointer'>${params.data.versionNumber}</span>`;
};

export const dataSourceNameRenderer = (params: ICellRendererParams) => {
  if (params.value) {
    return params.value;
  } else {
    return t('noDataSource');
  }
};
